import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import BlogPage from "./pages/BlogPage";
import CommercialPage from "./pages/CommercialPage";
import CustomDoorsPage from "./pages/CustomDoorsPage";
import GuidePage from "./pages/GuidePage";
import AdminPage from "./pages/AdminPage";
import GaRouteTracker from "./components/site/GaRouteTracker";
import { Toaster } from "./components/ui/sonner";

function App() {
  useEffect(() => {
    document.documentElement.classList.remove("dark");
  }, []);

  return (
    <div className="App font-nunito text-neutral-800">
      <BrowserRouter>
        <GaRouteTracker />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/commercial" element={<CommercialPage />} />
          <Route path="/doors" element={<CustomDoorsPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPage />} />
          <Route path="/guide" element={<GuidePage />} />
          <Route path="/lp/guide" element={<GuidePage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="*" element={<BlogPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
